<template>
  <div class="pb-5">
    <nav-bar />
    <div class="container-fluid mx-2">
      <div class="card mt-4">
        <div class="row mt-4 ml-2 mr-1">
          <div class="col-12 col-lg-6 pl-1 pr-2">
            <regular-select :value="$t('Dashboard.' + zoneParamToShow.label)" @change="onZoneParamChange"
               class="border form-group" style="width:210px">
              <option v-for="param in zoneParamOptions.map(item => $t('Dashboard.' + item.label))" :key="param" :value="param">{{ param }}
              </option>
            </regular-select>
            <div class="card-block p-3 pb-4 border cursor-pointer filtered-zones-accordion" data-toggle="collapse" data-parent="#accordion"
            :href="'#zone-multi-select'" aria-expanded="true"
            >
              <div class="accordion-header" @click="isZoneMultiSelectExpanded = !isZoneMultiSelectExpanded">
                <div class="header font-grey d-flex justify-content-between">
                  <div class="d-flex flex-column justify-content-between">
                    <p>{{$t('Dashboard.change_selected_zones')}}</p>
                    <p class="pull-right small">{{filteredZones.length}} {{$t('Dashboard.selected')}}</p>
                  </div>
                  <i v-if="isZoneMultiSelectExpanded" class="fas fa-chevron-up"></i>
                <i v-else class="fas fa-chevron-down"></i>
                </div>
              </div>
              <div :id="'zone-multi-select'" @click.stop class="collapse accordion-body-custom mt-4" role="tabpanel"
                aria-labelledby="headingOne">
                <multi-select class="multi-select-vue zone-multi-select" :options="zones"
                  :selected-options="filteredZones" @select="filterZones"
                  :placeholder="$t('Zone.modal.filter_zones.select_pick')" />
              </div>
            </div>
            <div class="zone-chart mt-4">
              <heat-map @highlightTableRow="highlightTableRow" :zoneParamToShow="zoneParamToShow" :coordinates="zoneDataForHeatMap"
                v-if="zoneDataLoaded"></heat-map>
            </div>
          </div>
          <div class="col-12 col-lg-6 pl-1 pr-2">
            <table-element ref="tableElement" :title="$t('Zone stats')" :fields="fieldsObj" :arrOfElement="zoneTableData" :sortSpacing="0"
              :isShowFilter="false" class="card mx-2 mt-4" :pageSize="300">
              <template #body-content-desktop="content">
                <tr
                :data-zone-name="item.zoneName"
                :class="{'highlightedRow': item.zoneName === clickedRow}"
                 v-for="(item, index) in content.results" class="table-element_hover text-center draggable-item"
                  :id="item.zoneName" :key="item.zoneName">
                  <td>
                    <span class="nowrap table-fix-width">{{ item.zoneName }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.processing }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.dispatch }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.pick }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.transit }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.transfer }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.reject }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.vehiclesLate }}</span>
                  </td>
                  <td>
                    <span class="nowrap table-fix-width">{{ item.adt }}</span>
                  </td>
                </tr>
              </template>
            </table-element>
          </div>

        </div>

      </div>
      <div class="row">
        <div class="col-12 col-lg-6 pr-2 pl-1">
          <!-- <new-update-list></new-update-list> -->
          <div class="mt-2 card">
            <h3 class="kne-title">{{ $t('Dashboard.statistic_title') }}</h3>
            <div class="filter-container">
              <multi-select class="multi-select-vue" :options="orderStatuseOptions"
                :selected-options="filteredOrderStatuses" @select="filterOrderStatuses"
                :placeholder="$t('Zone.modal.filter_zones.select_pick')" />
              <i style="margin-left: auto" class="fa fa-refresh cursor-pointer" @click="resetFilters" aria-hidden="true" />
              <div style="margin-left: auto">
                <date-range-picker ref="picker"
                :linkedCalendars="false"
                :maxDate="maxDate"
                v-model="dateRange"
                :show-dropdowns="true"
                ></date-range-picker>
              </div>
            </div>
            <div class="w-100 p-4">
              <bar-chart :chart-data="{
                labels: filteredOrderStatuses.map(item => item.value),
                datasets: [{
                  label: $t('OrderCurrent.title'),
                  backgroundColor: filteredOrderStatuses.map(item => item.color),
                  data: filteredOrderStatuses.map(item => item.count)
                }]
              }" :options="{ responsive: true, maintainAspectRatio: false }">
              </bar-chart>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 pl-1 pr-2">
          <new-update-list></new-update-list>
          <!-- <div class="mt-2 card">
            <h3 class="font-grey kne-title">{{$t('Dashboard.new_note_title')}}</h3>
            <regular-textarea
              :value="note.text"
              @input="note.text = $event"
              :placeholder="$t('Dashboard.new_note_message')" class="p-2" rows="4"/>
            <div class="container pb-2">
              <div class="row">
                <regular-input
                  :value="note.name"
                  @input="note.name = $event"
                  :placeholder="$t('Dashboard.new_note_name')" class="col-12 col-md-6 pl-2 pr-1"/>
                <div class="col-12 col-md-6 pr-2 pl-1">
                  <button class="btn btn-kne-orange w-100" :disabled="!noteFilled" @click="send()">
                    {{$t('General.create')}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-2 card">
            <h3 class="font-grey kne-title">{{$t('Dashboard.notes_title')}}</h3>
            <paginate-links for="reversedNotes" :hide-single-page="true" :limit="5"></paginate-links>
            <paginate name="reversedNotes" tag="div" :list="reversedNotes" class="" :per="12">
              <transition-group name="fade" tag="div">
                <div v-for="note in paginated('reversedNotes')" class="card-block p-3 pb-4 message" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + note['.key']" aria-expanded="true" :aria-controls="'#collapse' + note['.key']" :key="note['.key']">
                  <div :id="'collapse' + note['.key']" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                    <p class="text-justify">{{note.text}}</p>
                  </div>
                  <p class="header font-grey" id="notes">
                    <i>{{note.name}}</i>
                    <i class="pull-right">{{ getDate(note.date)}}</i>
                  </p>
                </div>
              </transition-group>
            </paginate>
          </div> -->
        </div>
      </div>

      
    </div>

  </div>
</template>

<script>
import barChart from '../module/special-components/Other-components/barChart.js'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularInput from '../module/basic-components/regularInput.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import {db} from '../../firebase'
import NewUpdateList from '../module/special-components/Other-components/NewUpdateList.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { MultiSelect } from 'vue-search-select'
import HeatMap from '../module/special-components/Other-components/HeatMap.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import { isRegularOrder } from '@/inventory/inventorySelectors'

export default {
  name: 'Dashboard',
  components: {
    barChart,
    regularTextarea,
    regularInput,
    NewUpdateList,
    DateRangePicker,
    MultiSelect,
    HeatMap,
    regularSelect,
    TableElement
  },
  data () {
    return {
      count: {
        processing: 0,
        dispatch: 0,
        pick: 0,
        transit: 0,
        drop: 0,
        transfer: 0,
        reject: 0
      },
      // note: {
      //   text: '',
      //   name: '',
      //   date: ''
      // },
      current: [],
      // notes: [],
      // reversedNotes: [],
      // paginate: ['reversedNotes'],
      initialDate: {
        startDate: this.getStartDate(),
        endDate: this.getEndDate()
      },
      dateRange: {},
      maxDate: new Date(),
      orderStatuseOptions: [
        { color: '#f7941e', index: 0, label: 'Processing', text: this.$t('OrderCurrent.stats.processing'), value: this.$t('OrderCurrent.stats.processing'), count: 0 },
        { color: '#ff5151', index: 1, label: 'Dispatch', text: this.$t('OrderCurrent.stats.dispatch'), value: this.$t('OrderCurrent.stats.dispatch'), count: 0 },
        { color: '#515eff', index: 2, label: 'Pick', text: this.$t('OrderCurrent.stats.pick'), value: this.$t('OrderCurrent.stats.pick'), count: 0 },
        { color: '#43de8f', index: 3, label: 'Transit', text: this.$t('OrderCurrent.stats.transit'), value: this.$t('OrderCurrent.stats.transit'), count: 0 },
        { color: '#de438b', index: 4, label: 'Drop', text: this.$t('OrderCurrent.stats.delivered'), value: this.$t('OrderCurrent.stats.delivered'), count: 0 },
        { color: '#43d7de', index: 5, label: 'Transfer', text: this.$t('OrderCurrent.stats.transferred'), value: this.$t('OrderCurrent.stats.transferred'), count: 0 },
        { color: '#decb43', index: 6, label: 'Reject', text: this.$t('OrderCurrent.stats.rejected'), value: this.$t('OrderCurrent.stats.rejected'), count: 0 }
      ],
      filteredOrderStatuses: [],
      zones: [],
      filteredZones: [],
      zoneOptions: [],
      zoneDataForHeatMap: {},
      zoneParamToShow: {label: '', value: ''},
      zoneParamOptions: [
        { label: 'processing', value: 'processing' },
        { label: 'dispatch', value: 'dispatch' },
        { label: 'pick', value: 'pick' },
        { label: 'transit', value: 'transit' },
        { label: 'transfered', value: 'transfer' },
        { label: 'rejected', value: 'reject' },
        { label: 'vehicle_late', value: 'vehiclesLate' },
        { label: 'average_delivery_time', value: 'adt' }
      ],
      zoneTableData: [],
      fieldsObj: [
       {
         text: this.$t('NavBar.zone'),
         type: 'zoneName',
         value: ''
       },
       {
        text: this.$t('Status.processing'),
        type: 'processing',
        value: ''
       },
       {
         text: this.$t('Status.dispatch'),
         type: 'dispatch',
         value: ''
       },
       {
         text: this.$t('Status.pick'),
         type: 'pick',
         value: ''
       },
       {
         text: this.$t('Status.transit'),
         type: 'transit',
         value: ''
       },
       {
         text: this.$t('Status.transfered'),
         type: 'transfer',
         value: ''
       },
       {
         text: this.$t('Status.rejected'),
         type: 'reject',
         value: ''
       },
       {
         text: this.$t('Dashboard.vehicle_late'),
         type: 'vehiclesLate',
         value: ''
       },
       {
         text: this.$t('Dashboard.average_delivery_time_days'),
         type: 'adt',
         value: ''
       }
      ],
      isZoneMultiSelectExpanded: false,
      clickedRow: '',
      zoneDataLoaded: false,
      ORDER_STATUSES: [
        'Processing',
        'Dispatch',
        'Pick',
        'Transit',
        'Transférée',
        'Reject'
      ],
      LATE_APPLICABLE_STATUSES: [
        'Processing',
        'Reject',
        'Attente',
        'Drop',
        'Reject',
        'Cancel',
        'Terminée'
      ]
    }
  },
  created () {
    // Get date range filter value from store if available
    if (!Object.keys(this.$store.state.dashboardFilterData.dateRange).length) {
      this.dateRange = this.initialDate
      this.$store.commit('updateDashboardFilterDateRange', this.dateRange)
    } else {
      this.dateRange = this.$store.state.dashboardFilterData.dateRange
    }
    // Get statuses filtered values from store if available
    if (!this.$store.state.dashboardFilterData.filteredOrderStatuses.length) {
      this.filteredOrderStatuses = this.orderStatuseOptions
      this.$store.commit('updateDashboardFilterOrderStatuses', this.filteredOrderStatuses)
    } else {
      const data = this.$store.state.dashboardFilterData.filteredOrderStatuses.map(item => {
        return this.orderStatuseOptions.filter(item2 => item.label === item2.label)[0]
      })
      this.filteredOrderStatuses = data
    }
    // Get highlighted row value from store if available
    if (this.$store.state.dashboardFilterData.highlightedRow !== '') {
      this.clickedRow = this.$store.state.dashboardFilterData.highlightedRow
    }
    // Get zone param value from store if available
    if (this.$store.state.dashboardFilterData.selectedZoneParam.label === '') {
      this.$store.commit('updateDashboardZoneSelectedParam', { label: 'processing', value: 'processing' })
    }
    this.zoneParamToShow = this.$store.state.dashboardFilterData.selectedZoneParam
    this.onDateRangePicked()
    this.getZones()
    // this.$bindAsArray('notes', db.ref('database/transporter/' + this.companyUID + '/notes/'), null, () => {
      // })
    // this.updateSeenUpdates()
  },

  computed: {
    regularCurrent () {
      return this.current.filter(isRegularOrder)
    },
    noteFilled () {
      if (this.note.text !== '' && this.note.name !== '') return true
      else return false
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isUserInfoLoaded () {
      return this.$store.state.userInfo
    },
    uid () {
      return this.$store.state.user.uid
    }
  },
  methods: {
    highlightTableRow (zoneName) {
      this.clickedRow = zoneName
      this.$refs.tableElement.scrollToRow(zoneName)
      this.$store.commit('updateDashboardhighlightedRow', zoneName)
    },
    onZoneParamChange (value) {
      this.zoneParamToShow = this.zoneParamOptions.filter(item => this.$t('Dashboard.' + item.label) === value)[0]
    },
    async getZones () {
      // Use zones from store
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      const storeZones = this.$store.state.zones
      if (!storeZones.length) return

      this.zones = storeZones.map(zone => ({
        value: zone.id,
        text: zone.zoneName,
        coordinates: zone.coordinates
      }))
      if (this.$store.state.dashboardFilterData.filteredZones.length > 0) {
        this.filteredZones = this.$store.state.dashboardFilterData.filteredZones
      } else {
        this.filteredZones = this.zones
      }
      this.zoneDataLoaded = true
    },
    getZoneCoordinates () {
      this.zoneTableData = []
      let data = {
        type: 'FeatureCollection',
        features: []
      }
      const features = this.filteredZones.map(zone => {
        // Get the params data for each zone
        let countProcessing = 0
        let countDispatch = 0
        let countPick = 0
        let countTransit = 0
        let countTransferred = 0
        let countReject = 0
        let vehiclesLate = 0
        let countDrop = 0
        let ADT = 0
        let totalDeliveryTime = 0
        let validOrdersCount = 0
        const currentDate = Date.now()
        const orders = this.regularCurrent.filter(order => order.receiverZone === zone.text || order.transmitterZone === zone.text)

        orders.forEach(order => {
            // Get avg delivery time
          if (order.status === 'Drop' && order.receiverZone === zone.text && order.historySync) {
            // Get the first pickDate from first history sync
            const pickDate = new Date(Object.entries(order.historySync)[0][1].pickDate) || NaN
            // Get the last dropDate from last history sync
            const dropDate = new Date(Object.entries(order.historySync)[Object.entries(order.historySync).length - 1][1].dropDate) || NaN
            console.log({zone: zone.text, pickDate, dropDate})
            if (!isNaN(pickDate.getTime()) && !isNaN(dropDate.getTime())) {
              const deliveryTimeMs = dropDate - pickDate
              const deliveryTimeDays = deliveryTimeMs / (1000 * 60 * 60 * 24)
              totalDeliveryTime += deliveryTimeDays
              console.log({deliveryTimeDays})
              validOrdersCount++
            }
          }
            // Get other statuses except vehicles late
             if (order.transmitterZone === zone.text) {
               if (order.status === 'Processing') {
                 countProcessing++
               } else if (order.status === 'Dispatch') {
                 countDispatch++
               } else if (order.status === 'Pick') {
                 countPick++
               } else if (order.status === 'Transit') {
                 countTransit++
               } else if (order.status === 'Transférée') {
                 countTransferred++
               } else if (order.status === 'Reject') {
                 countReject++
               } else {
                // Ignore other statuses
               }
              }
              // Get late vehicles for the zone
             if (!this.LATE_APPLICABLE_STATUSES.includes(order.status) && order.receiverZone === zone.text) {
               if (currentDate > order.lateTime) {
                 vehiclesLate++
               }
             }
         })
         if (validOrdersCount !== 0) {
           ADT = Math.round(totalDeliveryTime / validOrdersCount)
         }

        // Add the same data to the table
        this.zoneTableData.push({
          zoneName: zone.text,
          processing: countProcessing.toString(),
          dispatch: countDispatch.toString(),
          pick: countPick.toString(),
          transit: countTransit.toString(),
          transfer: countTransferred.toString(),
          reject: countReject.toString(),
          vehiclesLate: vehiclesLate.toString(),
          adt: ADT.toString()
        })
        return {
              type: 'Feature',
              properties: {
                name: zone.text,
                params: {
                  [this.$t('Dashboard.processing')]: countProcessing,
                  [this.$t('Dashboard.dispatch')]: countDispatch,
                  [this.$t('Dashboard.pick')]: countDrop,
                  [this.$t('Dashboard.transit')]: countTransit,
                  [this.$t('Dashboard.transfered')]: countTransferred,
                  [this.$t('Dashboard.rejected')]: countReject,
                  [this.$t('Dashboard.vehicle_late')]: vehiclesLate,
                  [this.$t('Dashboard.average_delivery_time')]: ADT
                }
              },
              geometry: {
                type: 'Polygon',
                coordinates: [
                 zone.coordinates
                ]
              }
      }
      })
      data.features = features
      this.zoneDataForHeatMap = data
      this.$store.commit('updateDashboardFilteredZones', this.filteredZones)
    },
    resetFilters () {
      this.filteredOrderStatuses = this.orderStatuseOptions
      this.dateRange = this.initialDate
    },
    filterOrderStatuses (statuses) {
      statuses.sort((a, b) => a.index - b.index)
        this.filteredOrderStatuses = statuses
        this.$store.commit('updateDashboardFilterOrderStatuses', statuses)
      },
    filterZones (selectedZones) {
      this.filteredZones = selectedZones
    },
    // updateSeenUpdates () {
    //   if (!this.isUserInfoLoaded) return

    //   let updatedFields = {
    //     isUpdateSeen: true
    //   }
    //   db.ref('users/transportersman/' + this.uid).update(updatedFields)

    //   this.$store.state.authorization.isUpdateSeen = true
    // },
    resetGMTOffsetToZero (date, isStartDate) {
      if (isStartDate) {
        date.setHours(0, 0, 0, 0)
      } else {
        date.setHours(23, 59, 59, 999)
      }
      const newDate = date.toString().replace(/GMT[+-]\d{4}/, 'GMT+0000')
      return new Date(newDate).valueOf()
    },
    onDateRangePicked () {
      const startAt = this.resetGMTOffsetToZero(this.dateRange.startDate, true)
      const endAt = this.resetGMTOffsetToZero(this.dateRange.endDate, false)
      this.$bindAsArray('current', db.ref('database/transporter').child(this.companyUID).child('deliveries')
        .orderByChild('creationDate')
        .startAt(startAt)
        .endAt(endAt)
        , null, () => {
          this.counts()
          this.filteredOrderStatuses = this.filteredOrderStatuses.map((item) => {
            item.count = this.count[`${item.label.toLowerCase()}`]
            return item
          })
        })
    },
    getStartDate () {
      const today = new Date()
      return new Date(new Date().setDate(today.getDate() - 30))
    },
    getEndDate () {
      return new Date()
    },
    counts () {
      for (var attr in this.count) this.count[attr] = 0
      this.regularCurrent.forEach((o) => {
        if (o.status === 'Processing') this.count.processing++
        if (o.status === 'Dispatch') this.count.dispatch++
        if (o.status === 'Pick') this.count.pick++
        if (o.status === 'Transit') this.count.transit++
        if (o.status === 'Drop') this.count.drop++
        if (o.status === 'Transférée') this.count.transfer++
        if (o.status === 'Reject') this.count.reject++
      })
      this.orderStatuseOptions = this.orderStatuseOptions.map((item) => {
            item.count = this.count[`${item.label.toLowerCase()}`]
            return item
          })
    }
    // send () {
    //   this.note.date = Date.now()
    //   db.ref('database/transporter/' + this.companyUID + '/notes/').push().set(this.note).then(() => {
    //     for (var attr in this.note) {
    //       this.note[attr] = ''
  //     }
    //   }).catch(function (error) {
    //     console.log(error)
    //   })
    // },

    // getDate: function (timestamp) {
    //   var date = new Date(timestamp)
    //   return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    // }
  },
  watch: {
    current: function () {
      this.counts()
      this.getZoneCoordinates()
    },
    filteredZones: function () {
      this.getZoneCoordinates()
    },
    dateRange: function () {
      this.$store.commit('updateDashboardFilterDateRange', this.dateRange)
      this.onDateRangePicked()
    },
    zoneParamToShow: function () {
      this.$store.commit('updateDashboardZoneSelectedParam', this.zoneParamToShow)
    }
    // notes: function (snapshot) {
    //   this.reversedNotes = JSON.parse(JSON.stringify(snapshot))
    //   this.reversedNotes.reverse()
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
  @media (max-width: 767px) {
    .btn {
      margin-top: .5rem
    }
  }
  #notes{
    overflow-wrap: break-word;
  }
  .filter-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:1rem;
    flex-wrap: wrap;
    gap:.25rem;
    font-size: 2ch;
  }
  .reportrange-text[data-v-1ebd09d2] {
    font-size: 12px !important;
  }
  .form-control{
    font-size: 12px;
  }
  .cursor-pointer{
    cursor: pointer;
  }
  .multi-select-vue{
    font-size: .75rem;
    width: auto !important;
    transition: width .2s ease;
    min-width: 150px !important;
  }
  .zone-chart{
    height: 100%;
    width: 100%;
  }
  .highlightedRow{
    background-color: #008000;
    color: white;
  }
  .highlightedRow:hover{
    background-color: #008000;
    color: white;
  }
  .filtered-zones-accordion{
    position: relative;
    z-index: 1000;
  }
</style>
